import { render, staticRenderFns } from "./DetaliiContractProductie.vue?vue&type=template&id=2b5a2c14&scoped=true"
import script from "./DetaliiContractProductie.vue?vue&type=script&lang=js"
export * from "./DetaliiContractProductie.vue?vue&type=script&lang=js"
import style0 from "./DetaliiContractProductie.vue?vue&type=style&index=0&id=2b5a2c14&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a2c14",
  null
  
)

export default component.exports